import ko from "knockout";
import _ from "underscore";

function CurveVariable(id, data, excludedData, average, name, displayName) {
  var self = this;
  self.id = id;
  self.excludedData = excludedData;
  self.average = ko.observable(average);
  self.data = data;
  self.name = name;
  self.displayName = displayName;
}

CurveVariable.prototype.getAverageText = function () {
  return this.average.toFixed(2);
};

export default CurveVariable;
